import {create} from 'zustand';
import {ChangeDataFormStateStore} from './types';
import {DEFAULT_FORM_STATE_STORE} from './constants';

export const useChangeDataFormStateStore = create<ChangeDataFormStateStore>((set, get) => ({
	formState: DEFAULT_FORM_STATE_STORE,
	updateFormState: partial =>
		set({
			formState: {
				...get().formState,
				...partial,
			},
		}),
	reset: () => set({formState: DEFAULT_FORM_STATE_STORE}),
}));
